<ng-container [ngSwitch]="currentStage">
  <div class="bl-overflow--none">
    <dx-instatouch
      class="bl-display--block bl-border-radius"
      [instaTouchState]="stage"
      [autofillField]="field"
      [isLoading]="isLoading"
      [errorMessage]="errorMessage"
      [showCodeSentAlert]="showCodeSentAlert"
      (getPassCode)="getPassCode($event)"
      (validatePassCode)="validatePassCode($event)"
      (getPersonalInfo)="getPersonalInfo($event)"
      (proceedWithoutPhone)="proceedWithoutPhonePrefill($event)"
    >
    </dx-instatouch>
  </div>
</ng-container>
